import type { DataSourceSortInfo } from "@infinite-table/infinite-react";
import type { QueryClient } from "@tanstack/react-query";
import type { ScreenerData } from "epsm-api-types/models";
import type { RefObject } from "react";

interface RemoveItemInCacheProps {
	ticker: string | undefined;
	queryClient: QueryClient;
	fetchDataRef: RefObject<string[] | DataSourceSortInfo<ScreenerData>>;
	columnOrder: string[];
}

export function removeItemInCache(props: RemoveItemInCacheProps) {
	const { ticker, queryClient, fetchDataRef, columnOrder } = props;

	queryClient.setQueryData<ScreenerData>(
		["ScreenerData", fetchDataRef.current, columnOrder],
		(oldData: any) => {
			if (!oldData) return oldData;
			return {
				...oldData,
				pages: oldData.pages.map((page: { data: ScreenerData[] }) => ({
					...page,
					data: page.data.filter((item) => item.ticker !== ticker),
				})),
			};
		},
	);
}
